import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { CurrentConfigDataInterface } from '../../models/dashboard/dashboard/currentConfigData';

interface IInitialState {
  currentConfigData?: CurrentConfigDataInterface;
}

const initialState: IInitialState = {
  currentConfigData: undefined
};

const currentConfigDataSlice = createSlice({
  name: 'currentConfigDataSlice',
  initialState,
  reducers: {
    setCurrentConfigData(state, action: PayloadAction<CurrentConfigDataInterface>) {
      state.currentConfigData = action.payload;
    },
  },
});

export const currentConfigDataActions = currentConfigDataSlice.actions;
export default currentConfigDataSlice.reducer;
